module.exports = __webpack_public_path__ + "static/media/pexels-photo-1640777.b4e0efb0.jpg";